module.exports = __webpack_public_path__ + "media/images/large-salon-word-9feaddff5f3644fb0e5f73ec62466598.svg";